import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TabComponent from 'src/components/Layout/TabComponent';
import AddDimensionComponent from 'src/components/Settings/QualityCheck/AddDimensionComponent';
import AddProductComponent from 'src/components/Settings/QualityCheck/AddProductComponent';
import {
  createQualityCheckProductAndDimension,
  updateQualityCheckProductAndDimension,
} from 'src/redux/Actions/VehicleTracking';
import { useNavigate, useLocation } from 'react-router-dom';
import Breadcrumb from 'src/components/Breadcrumb';
import { useSetBreadcrumbData } from 'src/utils/SetBreadcrumbData';
import BasicDeail from 'src/components/Settings/QualityCheck/BasicDetail';

export default function CreateQualityCheck() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const authReducer = useSelector((state) => state.AuthReducer);
  const tenantOrganisationId = authReducer?.userData?.organisations?.id;
  const themeColor = authReducer?.userData?.tenant?.theme;
  const [formErrors, setFormErrors] = useState({});
  const { qualityCheckDetail, qualityCheckUniqueNumber } = location.state || {};

  const [formData, setFormData] = useState({
    qualityCheckName: '',
    description: '',
    isActive: true,
    productIds: [],
    dimensions: [],
  });

  const accordionBasicDetailComponents = [
    {
      title: 'Basic Detail',
      component: (
        <BasicDeail
          formData={formData}
          setFormData={setFormData}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
        />
      ),
      error: formErrors.qualityCheckName || formErrors.description,
    },
    {
      title: 'Add Dimensions',
      component: (
        <AddDimensionComponent formData={formData} setFormData={setFormData} />
      ),
    },
    {
      title: 'Add Products',
      component: (
        <AddProductComponent formData={formData} setFormData={setFormData} />
      ),
    },
  ];

  const handleCreateQualityCheck = () => {
    const errors = {
      qualityCheckName: !formData.qualityCheckName,
      description: !formData.description,
    };
    setFormErrors(errors);
    if (errors.qualityCheckName || errors.description) return;

    const createData = {
      tenant_organisation_id: tenantOrganisationId,
      quality_check_name: formData.qualityCheckName,
      is_active: formData.isActive,
      description: formData.description,
      products: formData.productIds.map((productObj) => productObj.id),
      dimensions: formData.dimensions.map((dimensionObj) => ({
        dimension_id: dimensionObj.dimension_id,
        target_value: dimensionObj.targetValue ?? null,
        target_min_value: dimensionObj.targetMinValue ?? null,
        target_max_value: dimensionObj.targetMaxValue ?? null,
        target_boolean: dimensionObj.targetBoolean ?? null,
        target_option: dimensionObj.targetOption ?? null,
      })),
    };

    dispatch(createQualityCheckProductAndDimension(createData)).then(() => {
      navigate(-1);
    });
  };
  const handleUpdateQualityCheck = () => {
    const errors = {
      qualityCheckName: !formData.qualityCheckName,
      description: !formData.description,
    };
    setFormErrors(errors);
    if (errors.qualityCheckName || errors.description) return;

    const updateData = {
      tenant_organisation_id: tenantOrganisationId,
      quality_check_name: formData.qualityCheckName,
      quality_check_unique_number: qualityCheckUniqueNumber,
      is_active: formData.isActive,
      description: formData.description,
      products: formData.productIds.map((productObj) => ({
        product_id: productObj.id,
      })),
      dimensions: formData.dimensions.map((d) => ({
        dimension_id: d.dimension_id,
        target_value: d.targetValue ?? null,
        target_min_value: d.targetMinValue ?? null,
        target_max_value: d.targetMaxValue ?? null,
        target_boolean: d.targetBoolean ?? null,
        target_option: d.targetOption ?? null,
      })),
    };

    dispatch(updateQualityCheckProductAndDimension(updateData)).then(() => {
      navigate(-1);
    });
  };

  const submitButton = (
    <div className="div-flex-row cg-20">
      <button
        className={`common-btn-filled theme-background-${themeColor}`}
        onClick={
          qualityCheckDetail
            ? handleUpdateQualityCheck
            : handleCreateQualityCheck
        }
      >
        {qualityCheckDetail ? 'Update Quality Check' : 'Create Quality Check'}
      </button>
    </div>
  );

  const breadcrumbTitle = `${qualityCheckDetail ? 'Update' : 'Create'}`;

  useSetBreadcrumbData(location.pathname, breadcrumbTitle);

  useEffect(() => {
    if (qualityCheckDetail) {
      setFormData({
        qualityCheckName: qualityCheckDetail.qualityCheckName,
        description: qualityCheckDetail.description,
        isActive: qualityCheckDetail.isActive,
        productIds:
          qualityCheckDetail.products?.map((productIds) => ({
            id: productIds.product.id,
            name: productIds.product.name,
            description: productIds.product.description,
          })) || [],
        dimensions:
          qualityCheckDetail.dimensions?.map((dim) => ({
            dimension_id: dim.dimension.id,
            targetValue: dim.target_value,
            targetMinValue: dim.target_min_value,
            targetMaxValue: dim.target_max_value,
            targetBoolean: dim.target_boolean,
            targetOption: dim.target_option?.map((opt) => opt.id) || [],
          })) || [],
      });
    }
  }, [qualityCheckDetail]);

  return (
    <div className="page-layout div-flex-column">
      <div className="div-flex-column rg-5 horizontal-padding-10 border-bottom">
        <div className="div-flex-row cg-5">
          <Breadcrumb />
        </div>
        <div className="text-xxl text-semi-bold left-padding">
          {qualityCheckDetail ? 'Update Quality Check' : 'Create Quality Check'}
        </div>
      </div>

      <div className="div-flex-column rg-10 padding-top-10">
        <div className="vertical-padding-10">
          <TabComponent
            accordionComponents={accordionBasicDetailComponents}
            submitButton={submitButton}
          />
        </div>
      </div>
    </div>
  );
}
